"use client";
import React from "react";
import type { IFormationDetail } from "@/types/formation";
import FicheHero from "./FicheHero";
import PriceCard from "./PriceCard";
import FichePresentation from "./FichePresentation";
import FicheObjectives from "./FicheObjectives";
import Testimonials from "../Home/Testimonials";
import CareerGuidance from "../Common/CareerGuidance";
import Faq from "../Common/Faq";
// import OrganismFormation from "./OrganismFormation";
// import Financing from "../Common/Financing";
import Sessions from "./Sessions";
import RecommendedFormations from "./RecommendedFormations";
import FicheStickyNav from "./FicheStickyNav";
import FicheStickyCta from "./FicheStickyCta";

interface FicheContentProps {
  formation: IFormationDetail;
}

const FicheContent: React.FC<FicheContentProps> = ({ formation }) => {
  return (
    <div className="flex flex-col w-full">
      {/* Mobile chrome — the header/anchors slide back in on scroll up, the CTAs
          stay pinned to the bottom the whole way down. */}
      <FicheStickyNav slug={formation.slug} />

      <div className="fiche-rail relative md:bg-[#EFEFEF] bg-white">
        {/* Row 1 — the hero keeps its own full-bleed background, so it spans every track */}
        <div className="lg:col-span-full lg:row-start-1">
          <FicheHero formation={formation} />
        </div>
        <div className="hidden lg:block lg:col-start-4 lg:row-start-1 lg:row-end-3 relative z-30 lg:pt-22 lg:pb-10">
          <PriceCard formation={formation} className="sticky top-6 w-full" />
        </div>

        {/* Row 2 — the content rail */}
        <div className="lg:col-start-2 lg:row-start-2 lg:pt-6 min-w-0">
          <FichePresentation formation={formation} />
          <FicheObjectives formation={formation} />
          {/* <FicheTargetAudience formation={formation} /> */}
          <Sessions
            sessions={formation.sessions}
            formationTitle={formation.title}
            formationTheme={formation.category}
          />
        </div>
      </div>
      <RecommendedFormations formation={formation} />
      <div id="évaluations" className="scroll-mt-36 lg:scroll-mt-24">
        <Testimonials
          testimonialCards={true}
          showButton={true}
          avis={formation.reviews}
          programName={formation.title}
          formationSlug={formation.slug}
        />
      </div>
      <div id="devis" className="scroll-mt-36 lg:scroll-mt-24">
        <CareerGuidance />
      </div>
      <div id="faq" className="scroll-mt-36 lg:scroll-mt-24">
        {/* The formation's own FAQ, else its category's, else the common one.
            JSON-LD is emitted by the page, and only for the formation's own. */}
        <Faq questions={formation.faq?.questions ?? []} />
      </div>
      <div
        id="financements"
        className="md:bg-[#EFEFEF] bg-white scroll-mt-36 lg:scroll-mt-24"
      >
        {/* <Financing /> */}
      </div>
      {/* <OrganismFormation formation={formation} /> */}

      <FicheStickyCta formation={formation} />
    </div>
  );
};

export default FicheContent;
